module.exports = __webpack_public_path__ + "img/reward-9.63aa0551.svg";